import React, { lazy, Suspense } from 'react';
import { Result, Spin } from 'antd';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import AuthLayout from '../pages/authentication/layout';
import { Button } from '../components/buttons/buttons';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Login = lazy(() => import('../pages/authentication/LogIn'));
const ForgotPassword = lazy(() => import('../pages/authentication/ForgotPassword'));
const Register = lazy(() => import('../pages/authentication/Register'));
const AcceptInvite = lazy(() => import('../pages/authentication/Accept-Invite'));

function NotFound() {
    return (
        <Result
            style={{
                margin: 'auto',
            }}
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            extra={
                <Link to="/login">
                    <Button size={'default'} to="/login" type="primary">
                        Back To Login
                    </Button>
                </Link>
            }
        />
    );
}

function FrontendRoutes() {
    // const location = useLocation();
    const isLoggedIn = useSelector((state) => state.auth.login);
    return (
        <Suspense
            fallback={
                <div className="spin">
                    <Spin />
                </div>
            }
        >
            <Switch>
                <Route exact path="/forgot-password" component={ForgotPassword} />
                <Route exact path="/login" component={Login} />
                <Route exact path="/register" component={Register} />
                <Route exact path="/accept-invite/" component={AcceptInvite} />
                {/* <Route path="/login/:orgCode" component={Login} /> */}
                {/* <Route exact path="/fbRegister" component={FbSignUp} /> */}
                {/* <Route exact path="/fbSignIn" component={FbLogin} /> */}
                <Route exact path="/">
                    {isLoggedIn ? <Redirect to="/admin" /> : <Redirect to="/login" />}
                </Route>
                <Route component={NotFound} />
            </Switch>
        </Suspense>
    );
}
export default AuthLayout(FrontendRoutes);
